/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type employee_selfservice_PersonalDataRequestResponse = {
    /**
     * ID is the change request id.
     */
    id: string;
    /**
     * Reason is the office's reason, set only for a rejected request.
     */
    reason?: string;
    /**
     * Section is the part of the personal data the request changes.
     */
    section: employee_selfservice_PersonalDataRequestResponse.section;
    /**
     * Status is the request's workflow state.
     */
    status: employee_selfservice_PersonalDataRequestResponse.status;
    /**
     * SubmittedAt is when the employee filed the request.
     */
    submittedAt: string;
};
export namespace employee_selfservice_PersonalDataRequestResponse {
    /**
     * Section is the part of the personal data the request changes.
     */
    export enum section {
        ADDRESS = 'address',
        PHONE = 'phone',
        EMERGENCY_CONTACTS = 'emergency_contacts',
    }
    /**
     * Status is the request's workflow state.
     */
    export enum status {
        PENDING = 'pending',
        APPROVED = 'approved',
        EXECUTED = 'executed',
        FAILED = 'failed',
        MANUAL = 'manual',
        REJECTED = 'rejected',
        RESOLVED = 'resolved',
        CANCELLED = 'cancelled',
    }
}

